import type { ComponentType } from 'react'
import { BackofficeSummaryWidget } from './BackofficeSummaryWidget'
import { ExecutiveProductionWidget } from './ExecutiveProductionWidget'
import { LeadGenerationKpiWidget } from './LeadGenerationKpiWidget'
import { MyProductivityWidget } from './MyProductivityWidget'
import { NotificationsUnreadWidget } from './NotificationsUnreadWidget'
import { SalesAgentsWidget } from './SalesAgentsWidget'
import { SavedViewWidget } from './SavedViewWidget'
import { TeamProductivityWidget } from './TeamProductivityWidget'
import type { WidgetProps } from './types'
import { WorkQueueSummaryWidget } from './WorkQueueSummaryWidget'

/** Chiave del catalogo del server -> componente. Una chiave senza componente non si disegna (nessun errore). */
export const WIDGET_COMPONENTS: Record<string, ComponentType<WidgetProps>> = {
  'my-productivity': MyProductivityWidget,
  'team-productivity': TeamProductivityWidget,
  'sales-agents': SalesAgentsWidget,
  'work-queue-summary': WorkQueueSummaryWidget,
  'lead-generation-kpi': LeadGenerationKpiWidget,
  'executive-production': ExecutiveProductionWidget,
  'backoffice-summary': BackofficeSummaryWidget,
  'saved-view': SavedViewWidget,
  'notifications-unread': NotificationsUnreadWidget,
}
